import { __assign, __extends } from "tslib";
import React from "react";
import styles from "./PnmacChatWindow.styles.js";
import { Text, Image, View, Platform } from "react-native";
import PnmacMacChat from "../ChatBox";
import PnmacBubble from "../Bubble";
import PnmacLiveChat from "../LiveChat/PnmacLiveChat.js";
import tempdata from "../tempdata.js";
import _ from "underscore";
import { ConsoleView } from "react-device-detect";
import moment from "moment";
var PnmacChatWindow = /** @class */function (_super) {
  __extends(PnmacChatWindow, _super);
  function PnmacChatWindow(props) {
    var _this = _super.call(this, props) || this;
    _this.setChatState = function (newState) {
      _this.setState(newState);
      if (_this.chatRef && _this.chatRef.current && _this.chatRef.current.setChatState) {
        _this.chatRef.current.setChatState(newState);
      }
    };
    _this.scrollToLastMessage = function () {
      setTimeout(function () {
        var getFocusElements = document.querySelectorAll("[id ^= toFocus]");
        if (getFocusElements.length > 0) {
          var eleIdArray = [];
          getFocusElements.forEach(function (el) {
            eleIdArray.push(el.id);
          });
          var sortedGroup = eleIdArray.sort(function (a, b) {
            return b.time > a.time ? 1 : -1;
          });
          var lastElementToFocus = document.querySelector("#" + sortedGroup[0]);
          lastElementToFocus.scrollIntoView();
          var composer = document.querySelector('[data-testid="composer"]');
          if (composer && composer.focus) {
            composer.focus();
          }
        }
      }, 500);
    };
    _this.prepend = function (message) {
      _this.setState(function (previousState) {
        return {
          messages: PnmacMacChat.prepend(previousState.messages, [{
            _id: Math.round(Math.random() * 1000000),
            text: message.message,
            children: [],
            createdAt: new Date(),
            iconOnTopLeft: true,
            user: {
              _id: 2,
              name: "MaCh",
              avatar: "pennyIcon"
            }
          }]),
          loadEarlier: false,
          isLoadingEarlier: false,
          messageFrom: message.toUserId,
          messageTo: message.fromUserId,
          chatIsInitialized: true
        };
      });
    };
    _this.onLoadEarlier = function () {
      _this.setState(function (previousState) {
        return {
          isLoadingEarlier: true
        };
      });
    };
    _this.isChatAbused = function (previousState, data) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      var notHelpfulIntents = previousState.notHelpfulIntents + _.where((_b = (_a = data === null || data === void 0 ? void 0 : data.message) === null || _a === void 0 ? void 0 : _a.output) === null || _b === void 0 ? void 0 : _b.intents, {
        intent: "Not_Helpful"
      }).length || 0;
      // notHelpfulIntents += _.where(data?.message?.output?.intents, {
      //   intent: "nonsense",
      // }).length;
      var threatIntents = previousState.threatIntents + _.where((_d = (_c = data === null || data === void 0 ? void 0 : data.message) === null || _c === void 0 ? void 0 : _c.output) === null || _d === void 0 ? void 0 : _d.intents, {
        intent: "Threats"
      }).length || 0;
      var overrrideText = null;
      if (notHelpfulIntents > 4) {
        overrrideText = "If you have any questions please use the <a href='/MessageCenter'>Message Center</a> or <a href='/Home/Contact'>Contact Us</a> so we resolve any issues as quickly as possible.";
      }
      if (threatIntents > 2) {
        overrrideText = "I'm sorry you are frustrated. If you have any questions please use the <a href='/MessageCenter'>Message Center</a> or <a href='/Home/Contact'>Contact Us</a> so we resolve any issues as quickly as possible.";
      }
      if (previousState.prevIntents && previousState.prevIntents.length > 0 && ((_f = (_e = data === null || data === void 0 ? void 0 : data.message) === null || _e === void 0 ? void 0 : _e.output) === null || _f === void 0 ? void 0 : _f.intents) && ((_h = (_g = data === null || data === void 0 ? void 0 : data.message) === null || _g === void 0 ? void 0 : _g.output) === null || _h === void 0 ? void 0 : _h.intents.length) > 0) {
        var prevIntentRepeatedCount = _this.state.prevIntentRepeatedCount;
        if (previousState.prevIntents[0].intent == ((_k = (_j = data === null || data === void 0 ? void 0 : data.message) === null || _j === void 0 ? void 0 : _j.output) === null || _k === void 0 ? void 0 : _k.intents[0].intent)) {
          prevIntentRepeatedCount = prevIntentRepeatedCount + 1;
          setTimeout(function () {
            _this.setState({
              prevIntentRepeatedCount: prevIntentRepeatedCount
            });
          }, 500);
        }
      }
      return {
        notHelpfulIntents: notHelpfulIntents,
        threatIntents: threatIntents,
        result: notHelpfulIntents > 4 || threatIntents > 2 || prevIntentRepeatedCount > 4,
        message: overrrideText
      };
    };
    _this.customMessageForPaymentIntent = function (data) {
      var _a, _b, _c, _d;
      var message = null;
      var hasIntentToMakePayment = _.filter((_b = (_a = data === null || data === void 0 ? void 0 : data.message) === null || _a === void 0 ? void 0 : _a.output) === null || _b === void 0 ? void 0 : _b.intents, function (i) {
        return i.intent == "Make_Payment" || i.intent == "Automatic_Payments";
      }).length > 0;
      var hasIntentToKnowAboutPayment = _.filter((_d = (_c = data === null || data === void 0 ? void 0 : data.message) === null || _c === void 0 ? void 0 : _c.output) === null || _d === void 0 ? void 0 : _d.intents, function (i) {
        return i.intent == "PaymentAmount" || i.intent == "PaymentDueDate";
      }).length > 0;
      if (hasIntentToMakePayment) {
        //Please look at the <a href='\StatementsAndDocuments\'>Monthly Statement</a> to review your balance information
        message = "Based on the status of your loan, access to this feature may not be available. Please review your <a href='StatementsAndDocuments'>monthly statement</a> for more details.";
      } else if (hasIntentToKnowAboutPayment) {
        message = "If you are attempting to review payment information and you cannot, its most likely due to the status of your loan. Please <a href='HomeContact'>Contact Us</a> to confirm.";
      }
      return message;
    };
    _this.processChatApiResponse = function (da, callbackAfterWork) {
      // da = {"message":{"output":{"generic":[{"response_type":"text","text":"<img  src=\"https://s3-us-west-2.amazonaws.com/pnmac-customers-email-images-dev/MacChat/The_Sun_Emoji.png\" alt=\"Penny\" height=\"25px\" align=\"middle\"> Good Morning Yijie! I'm <b>Penny</b>, your automated assistant."},{"response_type":"text","text":"I'm here to help guide you to answers for common topics such as:"},{"response_type":"option","title":"","options":[{"label":"COVID-19 (Coronavirus)","value":{"input":{"text":"COVID-19 (Coronavirus)"}}},{"label":"Statements","value":{"input":{"text":"Statements"}}},{"label":"Payment Options","value":{"input":{"text":"Payment Options"}}},{"label":"Account Profile","value":{"input":{"text":"Account Profile"}}},{"label":"Escrow Topics","value":{"input":{"text":"Escrow Topics"}}},{"label":"Technical Issues","value":{"input":{"text":"Technical Issues"}}}]}],"intents":[{"intent":"General_Greetings","confidence":0.9760615348815918}],"entities":[]},"context":{"global":{"system":{"user_id":"46cc187b-562e-4a88-88ad-339d2db5c7b4","turn_count":1}},"skills":{"main skill":{"user_defined":{"platform":"web","ReqDateTime":"Monday, 02 August 2021","ReqDateTimeToDisplay":"2021-08-02T10:17:26","ReqDate":"08/02/2021","ReqTimeToDisplay":"10:17 AM","ReqTime":"10:17","ReqTimeHour":10,"ReqTimeMinute":17,"ReqDay":2,"ReqDayToDisplay":"Monday","ReqTimeMonth":8,"ReqTimeMonthName":"August","ReqTimeYear":2021,"HasPrepayPenalty":"","HasEscrow":"True","HasTaxes":"True","HasMultipleTaxAccounts":"True","TaxResponsiblePartiesCount":"4","HasInsurances":"True","HasMultipleInsuranceAccounts":"True","LoanHasRecentEscrowRefundActivity":"False","RecentEscrowRefundCheckMailDateAvailable":"False","RecentEscrowRefundCheckGeneratedDateAvailable":"False","CanMakePayment":"True","HasLoanActivity":"True","IsHelocLoan":"False","YesDataSwitch":"","Is1099IntMailed":"[ERROR]","Is1098Mailed":"[ERROR]","TaxDispositionIndicator1098":"[ERROR]","TaxDispositionIndicator1099INT":{"Result":"[ERROR]","Id":6108,"Exception":null,"Status":5,"IsCanceled":false,"IsCompleted":true,"IsCompletedSuccessfully":true,"CreationOptions":0,"AsyncState":null,"IsFaulted":false},"TaxLetterStatus1098":"[ERROR]","TaxLetterStatus1099INT":"[ERROR]","Is1098I30":"[ERROR]","Is1099I30":"[ERROR]","HasNetFeeAmount":"False","AggregatedFeeDataCount":"41","AssessedFeeTransactionCount":"0","HasAssessedFeeTransactions":"False"},"system":{}}}}},"sessionId":"6c824487-0719-4a2d-90c5-5d98317b8413","userChatSessionId":11918,"rawOuput":"<img  src=\"https://s3-us-west-2.amazonaws.com/pnmac-customers-email-images-dev/MacChat/The_Sun_Emoji.png\" alt=\"Penny\" height=\"25px\" align=\"middle\"> Good Morning [FirstName]! I'm <b>Penny</b>, your automated assistant.I'm here to help guide you to answers for common topics such as:COVID-19 (Coronavirus)StatementsPayment OptionsAccount ProfileEscrow TopicsTechnical Issues","macChatOutput":"<img  src=\"https://s3-us-west-2.amazonaws.com/pnmac-customers-email-images-dev/MacChat/The_Sun_Emoji.png\" alt=\"Penny\" height=\"25px\" align=\"middle\"> Good Morning Yijie! I'm <b>Penny</b>, your automated assistant.I'm here to help guide you to answers for common topics such as:COVID-19 (Coronavirus)StatementsPayment OptionsAccount ProfileEscrow TopicsTechnical Issues","env":{"canMakePayment":true}};
      var blockSession = false;
      var transferToLiveAgent = _this.state.transferToLiveAgent;
      _this.setState(function (previousState) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        var chatAbusedResult = _this.isChatAbused(previousState, da);
        blockSession = chatAbusedResult.result;
        var customMessage = null;
        var textMessage = (_c = (_b = (_a = da === null || da === void 0 ? void 0 : da.message) === null || _a === void 0 ? void 0 : _a.output) === null || _b === void 0 ? void 0 : _b.generic.filter(function (s) {
          return s.response_type == "text" && s.text || s.response_type == "option" && s.text;
        })) === null || _c === void 0 ? void 0 : _c.reduce(function (a, i) {
          return a += i.text;
        }, "");
        if (textMessage) {
          var showErrorText = false;
          if (blockSession) {
            customMessage = chatAbusedResult.message;
          } else if (_this.props.fnCanMakeAPayment && !_this.props.fnCanMakeAPayment()) {
            customMessage = _this.customMessageForPaymentIntent(da);
          }
        }
        if (_this.props.liveAgentEnabled && ((_h = (_g = (_f = (_e = (_d = da === null || da === void 0 ? void 0 : da.message) === null || _d === void 0 ? void 0 : _d.context) === null || _e === void 0 ? void 0 : _e.skills) === null || _f === void 0 ? void 0 : _f["main skill"]) === null || _g === void 0 ? void 0 : _g.user_defined) === null || _h === void 0 ? void 0 : _h.Allowliveagent) == "True") {
          var intentsToTriggerConnect = ["general_connect_to_agent", "anything_else", "unknown"];
          if (_this.props.intentsToTriggerConnect) {
            intentsToTriggerConnect = _this.props.intentsToTriggerConnect;
          }
          if (((_k = (_j = da === null || da === void 0 ? void 0 : da.message) === null || _j === void 0 ? void 0 : _j.output) === null || _k === void 0 ? void 0 : _k.intents) != null && ((_m = (_l = da === null || da === void 0 ? void 0 : da.message) === null || _l === void 0 ? void 0 : _l.output) === null || _m === void 0 ? void 0 : _m.intents.length) > 0) {
            var livePersonIntent = _.find((_p = (_o = da === null || da === void 0 ? void 0 : da.message) === null || _o === void 0 ? void 0 : _o.output) === null || _p === void 0 ? void 0 : _p.intents, function (data) {
              if (data.intent) {
                return intentsToTriggerConnect.filter(function (i) {
                  return i.toLowerCase() == data.intent.toLowerCase();
                }).length > 0;
              }
              return false;
            });
            if (livePersonIntent) {
              transferToLiveAgent = true;
            }
          }
          if (transferToLiveAgent) {
            _this.setChatState({
              chatBusyState: "isBusy"
            });
            if (_this.props.onLiveAgentInitCalled) {
              _this.props.onLiveAgentInitCalled();
            }
            var mess_1 = previousState.messages;
            var thisSesssionId = mess_1.length > 0 ? mess_1[0].sessionId : _this.state.sessionId;
            _this.props.socketRequest(mess_1, {
              isBlocked: false,
              sessionId: thisSesssionId,
              transferToLiveAgent: true,
              lastWatsonMessage: textMessage,
              sessionId: da === null || da === void 0 ? void 0 : da.sessionId
            });
            return {
              messages: mess_1,
              loading: false,
              notHelpfulIntents: _this.state.notHelpfulIntents,
              threatIntents: _this.state.threatIntents,
              isBlocked: false,
              sessionId: thisSesssionId,
              latestChatRespContext: _this.state.latestChatRespContext,
              prevIntents: _this.state.prevIntents,
              transferToLiveAgent: true,
              lastWatsonMessage: textMessage
            };
          }
        }
        if (_this.props.test) {
          previousState = {
            messages: []
          };
        }
        var mess = PnmacMacChat.prepend(previousState.messages, [{
          _id: Math.round(Math.random() * 1000000),
          text: customMessage ? customMessage : textMessage,
          children: customMessage ? [] : ((_s = (_r = (_q = da === null || da === void 0 ? void 0 : da.message) === null || _q === void 0 ? void 0 : _q.output) === null || _r === void 0 ? void 0 : _r.generic.find(function (s) {
            return s.response_type == "option" || s.response_type == "suggestion";
          })) === null || _s === void 0 ? void 0 : _s.options) || [],
          createdAt: new Date(),
          user: {
            _id: Math.round(Math.random() * 1000000),
            name: "MaCh",
            avatar: "pennyIcon"
          },
          intents: ((_u = (_t = da === null || da === void 0 ? void 0 : da.message) === null || _t === void 0 ? void 0 : _t.output) === null || _u === void 0 ? void 0 : _u.intents) || [],
          iconOnTopLeft: true,
          sessionId: da.sessionId,
          userChatSessionId: da.userChatSessionId,
          isBlocked: blockSession
        }]);
        var thisSesssionId = mess.length > 0 ? mess[0].sessionId : _this.state.sessionId;
        _this.props.socketRequest(mess, {
          isBlocked: chatAbusedResult.result,
          sessionId: thisSesssionId,
          transferToLiveAgent: transferToLiveAgent,
          userChatSessionId: da === null || da === void 0 ? void 0 : da.userChatSessionId
        });
        if (_this.props.speak) {
          _this.props.speak(customMessage || textMessage);
        }
        return {
          messages: mess,
          loading: false,
          notHelpfulIntents: chatAbusedResult.notHelpfulIntents,
          threatIntents: chatAbusedResult.threatIntents,
          isBlocked: chatAbusedResult.result,
          sessionId: thisSesssionId,
          latestChatRespContext: (_v = da === null || da === void 0 ? void 0 : da.message) === null || _v === void 0 ? void 0 : _v.context,
          prevIntents: (_x = (_w = da === null || da === void 0 ? void 0 : da.message) === null || _w === void 0 ? void 0 : _w.output) === null || _x === void 0 ? void 0 : _x.intents,
          transferToLiveAgent: transferToLiveAgent,
          userChatSessionId: da === null || da === void 0 ? void 0 : da.userChatSessionId
        };
      }, _this.scroller && _this.scroller.scrollToEnd ? _this.scroller.scrollToEnd({
        animated: true
      }) : _this.scrollToLastMessage());
      if (callbackAfterWork) {
        callbackAfterWork(blockSession ? "blockSession" : null);
      }
    };
    _this.createAgentTrackerData = function (inputMessage, contactId, initialContactId) {
      var context = {
        contactId: contactId,
        initialContactId: initialContactId,
        borrowerId: _this.props.borrowerId
      };
      var data = {
        sessionId: _this.state.userChatSessionId,
        userInput: inputMessage,
        userOutput: null,
        chatContext: JSON.stringify(context),
        requestedOn: new Date().toJSON(),
        respondedOn: null,
        loanId: _this.props.loanId,
        intentConfidence: 1
      };
      return data;
    };
    _this.onSend = function (messages, callbackAfterWork) {
      if (messages === void 0) {
        messages = [];
      }
      _this.setState({
        loading: true
      });
      _this.onReceive(messages);
      if (!(_this.scroller && _this.scroller.scrollToEnd)) {
        _this.scrollToLastMessage();
      }
      if (_this.state.transferToLiveAgent) {
        if (_this.state.liveChatSession && _this.state.liveChatSession.controller) {
          try {
            _this.state.liveChatSession.controller.sendMessage({
              message: messages[0].text,
              contentType: "text/plain"
            });
            var agentTrackerData = _this.createAgentTrackerData(messages[0].text, _this.state.liveChatSession.controller.contactId, _this.state.liveChatSession.controller.initialContactId);
            _this.setState({
              agentTrackerData: agentTrackerData
            });
            // setTimeout(() => {
            //   this.setChatState({ chatBusyState: "isReady" });
            //   this.setState({ loading: false,  });
            // }, 100);
            if (callbackAfterWork) {
              callbackAfterWork();
            }
            return;
          } catch (e) {
            console.log(e);
          }
        }
      }
      fetch(_this.props.url, {
        method: "POST",
        body: JSON.stringify({
          message: messages[0].text,
          sessionId: _this.state.sessionId,
          loanId: _this.props.loanId,
          mobile: _this.props.mobile,
          userChatSessionId: _this.state.userChatSessionId,
          previousContext: _this.state.latestChatRespContext,
          utcOffset: moment().utcOffset(),
          clientDate: moment().format('L'),
          clientHour: moment().hour(),
          clientMinute: moment().minute(),
          clientSecond: moment().second()
        }),
        headers: {
          Authorization: "Bearer ".concat(_this.props.token),
          "Content-Type": "application/json"
        }
      }).then(function (data) {
        return data.json ? data.json() : data;
      }).then(function (da) {
        _this.processChatApiResponse(da, callbackAfterWork);
      });
    };
    _this.onReceive = function (messages) {
      _this.setState(function (previousState) {
        if (_this.props.test) {
          previousState = {
            messages: []
          };
        }
        var msgs = {
          messages: PnmacMacChat.prepend(previousState.messages, messages)
        };
        return msgs;
      });
    };
    _this.renderBubble = function (props) {
      var elId = "toFocus" + Date.now();
      return /*#__PURE__*/React.createElement(PnmacBubble, __assign({
        scrollId: elId
      }, props, {
        wrapperStyle: {
          left: {
            backgroundColor: "#F5F5F5"
          },
          right: {
            backgroundColor: "#00789D",
            color: "white"
          }
        }
      }));
    };
    _this.messaging = function () {
      var that = _this;
    };
    _this.toggleLivePerson = function () {
      _this.setState({
        toggledState: !_this.state.toggledState
      }, function () {
        if (_this.state.toggledState) {} else {}
      });
    };
    _this.onKeyPress = function (data, onSend) {
      if (data.event && data.event.keyCode === 13) {
        onSend();
      }
    };
    _this.handleLiveConnectedEvt = function (connectResp, data) {
      _this.setState({
        liveAgentIsActive: true
      });
      if (_this.props.onAgentConnectionSuccess) {
        _this.props.onAgentConnectionSuccess(connectResp, data);
      }
    };
    _this.handleLiveConnectFailedEvt = function (connectErrResp) {
      _this.setState({
        liveAgentIsActive: false
      });
      _this.setChatState({
        chatBusyState: "isReady"
      });
      if (_this.props.onAgentConnectionFail) {
        _this.props.onAgentConnectionFail(connectErrResp);
      }
    };
    _this.handleLiveMessageReceivedEvt = function (message, contactDetails) {
      _this.setState({
        liveAgentIsTyping: false
      });
      var _a = _this.state,
        transferToLiveAgent = _a.transferToLiveAgent,
        liveAgentIsActive = _a.liveAgentIsActive,
        messages = _a.messages,
        liveAgentIsLoading = _a.liveAgentIsLoading;
      var agentTrackerData = _this.state.agentTrackerData;
      var liveAgentName = "Penny";
      var messageText = null;
      var avatar = null;
      if (message) {
        if (message == "IGNORE_MESSAGE") {
          messageText = null;
          if (contactDetails.liveAgentTimerId) {
            _this.setState({
              liveAgentTimerId: contactDetails.liveAgentTimerId
            });
          }
        } else if (message == "MSG_CANNOT_CONNECT") {
          message = {
            DisplayName: "Penny"
          };
          messageText = _this.state.lastWatsonMessage;
          if (!messageText || messageText == "") {
            messageText = "Something went wrong. Please use the <a href='/MessageCenter'>Message Center</a> or <a href='/Home/Contact'>Contact Us</a> so we resolve any issues as quickly as possible.";
          }
          transferToLiveAgent = false;
          liveAgentIsActive = false;
          _this.setState({
            transferToLiveAgent: transferToLiveAgent,
            liveAgentIsActive: liveAgentIsActive,
            liveChatSession: null,
            liveAgentIsLoading: false
          });
        } else if (message == "MSG_SOMETHING_WRONG") {
          if (_this.state.liveAgentName != "Penny") {
            messageText = "Something went wrong. Please use the <a href='/MessageCenter'>Message Center</a> or <a href='/Home/Contact'>Contact Us</a> so we resolve any issues as quickly as possible.";
          } else {
            messageText = _this.state.lastWatsonMessage;
          }
          if (messageText == "") {
            messageText = "Something went wrong. Please use the <a href='/MessageCenter'>Message Center</a> or <a href='/Home/Contact'>Contact Us</a> so we resolve any issues as quickly as possible.";
          }
          transferToLiveAgent = false;
          liveAgentIsActive = false;
          _this.setState({
            transferToLiveAgent: transferToLiveAgent,
            liveAgentIsActive: liveAgentIsActive,
            liveAgentIsLoading: false
          });
        } else if (message.ParticipantRole != "CUSTOMER") {
          switch (message.ContentType) {
            case "application/vnd.amazonaws.connect.event.participant.joined":
              messageText = "".concat(message.DisplayName, " has joined to help you out.");
              liveAgentIsActive = true;
              liveAgentName = message.DisplayName;
              message.DisplayName = "Penny";
              liveAgentIsLoading = false;
              if (_this.state.liveAgentTimerId) {
                clearTimeout(_this.state.liveAgentTimerId);
              }
              try {
                if (_this.props.getHistoryToAgentForContext) {
                  setTimeout(function () {
                    var message = _this.props.getHistoryToAgentForContext();
                    _this.state.liveChatSession.controller.sendMessage({
                      message: message,
                      contentType: "text/plain"
                    });
                  }, 200);
                }
              } catch (error) {
                console.log("Error sending context", error);
              }
              break;
            case "application/vnd.amazonaws.connect.event.participant.left":
              messageText = "".concat(_this.state.liveAgentName || message.DisplayName, " left the chat.");
              liveAgentName = message.DisplayName;
              message.DisplayName = "Penny";
              _this.setState({
                liveAgentIsActive: false,
                transferToLiveAgent: false,
                liveAgentIsLoading: false
              });
              break;
            case "application/vnd.amazonaws.connect.event.chat.ended":
              if (message.Content == "AGENT_COULD_NOT_RESPOND") {
                message = {
                  DisplayName: "Penny"
                };
                messageText = "Sorry, the agent is not available at this time. Please continue to send us a message using the <a href=\"/MessageCenter\">Secure Message</a>.  Depending on your question, it may take 1 to 3 business days for a response to come back in your <b>'Inbox'</b>.";
              }
              _this.setState({
                liveAgentIsActive: false,
                transferToLiveAgent: false,
                liveAgentIsLoading: false
              });
              break;
            case "text/plain":
              messageText = message.Content;
              liveAgentName = message.DisplayName;
              break;
            default:
              break;
          }
        }
        if (messageText) {
          if (agentTrackerData) {
            agentTrackerData.userOutput = messageText;
            agentTrackerData.respondedOn = new Date().toJSON();
          } else {
            agentTrackerData = _this.createAgentTrackerData("", contactDetails.contactId, contactDetails.initialContactId);
            agentTrackerData.userOutput = messageText;
            agentTrackerData.respondedOn = new Date().toJSON();
          }
          setTimeout(function () {
            if (message.DisplayName == "Penny") {
              avatar = "pennyIcon";
              message.DisplayName = "MaCh";
            }
            _this.setState(function (previousState) {
              var mess = PnmacMacChat.prepend(previousState.messages, [{
                _id: Math.round(Math.random() * 1000000),
                text: messageText,
                children: [],
                createdAt: new Date(),
                user: {
                  _id: Math.round(Math.random() * 1000000),
                  name: message.DisplayName,
                  avatar: avatar
                },
                intents: [],
                iconOnTopLeft: true,
                sessionId: _this.state.sessionId,
                userChatSessionId: _this.state.userChatSessionId,
                isBlocked: false,
                fromLiveAgent: true
              }]);
              _this.props.socketRequest(mess, {
                isBlocked: false,
                sessionId: _this.state.sessionId
              });
              return {
                messages: mess,
                loading: false,
                notHelpfulIntents: _this.state.notHelpfulIntents,
                threatIntents: _this.state.threatIntents,
                isBlocked: false,
                sessionId: _this.state.sessionId,
                latestChatRespContext: _this.state.latestChatRespContext,
                prevIntents: _this.state.prevIntents,
                liveAgentName: liveAgentName,
                liveAgentIsLoading: liveAgentIsLoading
              };
            });
            _this.scroller && _this.scroller.scrollToEnd ? _this.scroller.scrollToEnd({
              animated: true
            }) : _this.scrollToLastMessage();
            _this.setChatState({
              chatBusyState: "isReady"
            });
          }, 500);
          if (agentTrackerData.sessionId && agentTrackerData.sessionId != 0 && agentTrackerData.userOutput && _this.props.agentSessionUrl) {
            _this.trackAgentSession(agentTrackerData);
          }
        }
      }
      if (_this.props.onAgentMessageReceived) {
        _this.props.onAgentMessageReceived(message, {
          text: messageText,
          agent: liveAgentName,
          avatar: avatar,
          contactDetails: contactDetails
        });
      }
    };
    _this.trackAgentSession = function (agentTrackerData) {
      fetch(_this.props.agentSessionUrl, {
        method: "POST",
        body: JSON.stringify(agentTrackerData),
        headers: _this.props.token ? {
          Authorization: "Bearer ".concat(_this.props.token),
          "Content-Type": "application/json"
        } : {
          "Content-Type": "application/json"
        }
      });
    };
    _this.handleConnectSessionCreated = function (connectSession) {
      _this.setState({
        liveChatSession: connectSession
      });
      if (!_this.state.chatIsInitialized) {
        _this.setState({
          chatIsInitialized: true
        });
      }
      if (_this.props.onAgentSessionCreated) {
        _this.props.onAgentSessionCreated(connectSession);
      }
    };
    _this.handleAgentTypingEvt = function (event) {
      var _a = _this.state,
        liveAgentIsTyping = _a.liveAgentIsTyping,
        liveAgentName = _a.liveAgentName;
      _this.setState(function (previousState) {
        var _a;
        if ((event === null || event === void 0 ? void 0 : event.data) && ((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.ContentType) == "application/vnd.amazonaws.connect.event.typing") {
          //this.setState({ liveAgentIsTyping: !this.state.liveAgentIsTyping });
          liveAgentIsTyping = true;
        } else {
          //this.setState({ liveAgentIsTyping: false });
          liveAgentIsTyping = false;
        }
        if (_this.props.onLiveAgentTyping) {
          _this.props.onLiveAgentTyping(liveAgentIsTyping, {
            liveAgentName: liveAgentName,
            sessionId: _this.state.sessionId,
            userChatSessionId: _this.state.userChatSessionId
          });
        }
      });
      setTimeout(function () {
        _this.setState(function (previousState) {
          var typingMessage = null;
          var mess = [];
          if (previousState && previousState.messages) {
            typingMessage = _.find(previousState.messages, function (v) {
              return v.isTypingEvent;
            });
          }
          if (liveAgentIsTyping) {
            if (!typingMessage) {
              mess = PnmacMacChat.prepend(previousState.messages, [{
                _id: Math.round(Math.random() * 1000000),
                isTypingEvent: true,
                text: "",
                children: [],
                createdAt: new Date(),
                user: {
                  _id: Math.round(Math.random() * 1000000),
                  name: liveAgentName,
                  avatar: null
                },
                intents: [],
                iconOnTopLeft: true,
                sessionId: _this.state.sessionId,
                userChatSessionId: _this.state.userChatSessionId,
                isBlocked: false,
                fromLiveAgent: true
              }]);
            } else {
              return;
            }
          } else {
            if (typingMessage) {
              mess = _.filter(previousState.messages, function (v) {
                return !v.isTypingEvent;
              });
            } else {
              mess = previousState.messages;
            }
          }
          _this.props.socketRequest(mess, {
            isBlocked: false,
            sessionId: _this.state.sessionId,
            liveAgentName: liveAgentName
          });
          return {
            messages: mess,
            loading: false,
            notHelpfulIntents: _this.state.notHelpfulIntents,
            threatIntents: _this.state.threatIntents,
            isBlocked: false,
            sessionId: _this.state.sessionId,
            latestChatRespContext: _this.state.latestChatRespContext,
            prevIntents: _this.state.prevIntents,
            liveAgentName: liveAgentName,
            liveAgentIsTyping: liveAgentIsTyping
          };
        });
        _this.scroller && _this.scroller.scrollToEnd ? _this.scroller.scrollToEnd({
          animated: true
        }) : _this.scrollToLastMessage();
      }, 100);
    };
    _this.handleLiveConnectionDropEvt = function (data) {
      console.log("Live Agent connection dropped");
      _this.setState({
        liveAgentIsLoading: false
      });
      if (_this.props.onAgentSessionDropped) {
        _this.props.onAgentSessionDropped(data);
      }
    };
    _this.handleLiveAgentBusyEvt = function (isBusy) {
      _this.setState({
        liveAgentIsLoading: isBusy
      });
      if (_this.props.onAgentBusy) {
        _this.props.onAgentBusy(data);
      }
    };
    _this.state = {
      messages: [],
      loadEarlier: true,
      typingText: null,
      isLoadingEarlier: false,
      sessionId: props.sessionId || "",
      userChatSessionId: props.userChatSessionId || 0,
      messageFrom: "",
      messageTo: "",
      toggledState: false,
      loading: false,
      chatIsInitialized: props.chatIsInitialized || false,
      isSpeakerOn: props.isSpeakerOn || false,
      isListening: props.isListening || false,
      isSpeaking: props.isSpeaking || false,
      isBlocked: props.isBlocked || false,
      notHelpfulIntents: props.notHelpfulIntents || 0,
      threatIntents: props.threatIntents || 0,
      latestChatRespContext: null,
      prevIntents: null,
      prevIntentRepeatedCount: 1,
      transferToLiveAgent: props.transferToLiveAgent || false,
      liveAgentIsActive: false,
      liveAgentIsLoading: false,
      liveAgentIsTyping: false,
      liveChatSession: null,
      liveAgentName: props.liveAgentName || null,
      liveAgentTimerId: null,
      lastWatsonMessage: props.lastWatsonMessage || null,
      agentTrackerData: null
    };
    _this._isMounted = false;
    _this._isAlright = null;
    _this.chatRef = /*#__PURE__*/React.createRef();
    _this.scrollRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  PnmacChatWindow.prototype.componentDidMount = function () {
    var _this = this;
    var props = this.props;
    if (this.props.socketPrepend) {
      this.props.socketPrepend(this.prepend);
    }
    this._isMounted = true;
    if (!this.state.toggledState && !this.props.test) {
      if (this.props.existingMessages && this.props.existingMessages.length > 0 && (this.state.sessionId != "" || this.state.userChatSessionId > 0)) {
        this.setState(function () {
          if (_this.props.socketRequest) {
            _this.props.socketRequest(_this.props.existingMessages);
          }
          return {
            sessionId: _this.state.sessionId,
            userChatSessionId: _this.state.userChatSessionId || 0,
            messages: _this.props.existingMessages,
            chatIsInitialized: true,
            isBusy: false
          };
        }, this.scroller && this.scroller.scrollToEnd && this.state.chatIsInitialized === true ? this.scroller.scrollToEnd({
          animated: true
        }) : this.scrollToLastMessage());
      } else {
        //use only post in future to avoid problems with long text in query string for message. user can type
        //upto max 120 chars which may or may not cause problems depending on what they type.
        fetch(this.props.url, {
          method: "POST",
          body: JSON.stringify({
            loanId: this.props.loanId,
            mobile: this.props.mobile,
            sessionId: this.state.sessionId,
            userChatSessionId: this.state.userChatSessionId,
            previousResponse: this.state.latestChatRespContext,
            utcOffset: moment().utcOffset(),
            clientDate: moment().format('L'),
            clientHour: moment().hour(),
            clientMinute: moment().minute(),
            clientSecond: moment().second()
          }),
          headers: this.props.token ? {
            Authorization: "Bearer ".concat(this.props.token),
            "Content-Type": "application/json"
          } : {
            "Content-Type": "application/json"
          }
        }).then(function (data) {
          return data.json();
        }).then(function (da) {
          _this.processChatApiResponse(da);
        });
      }
    } else {
      this.setState({
        chatIsInitialized: true
      });
    }
  };
  PnmacChatWindow.prototype.componentWillUnmount = function () {
    this._isMounted = false;
  };
  PnmacChatWindow.prototype.render = function () {
    var _this = this;
    var _a;
    var _b = this.props,
      chatContainer = _b.chatContainer,
      header = _b.header,
      onLinkPress = _b.onLinkPress,
      mobile = _b.mobile,
      isMicOn = _b.isMicOn;
    var _c = this.state,
      loading = _c.loading,
      chatIsInitialized = _c.chatIsInitialized,
      isSpeakerOn = _c.isSpeakerOn,
      isListening = _c.isListening,
      isSpeaking = _c.isSpeaking,
      isBlocked = _c.isBlocked,
      liveAgentIsActive = _c.liveAgentIsActive,
      liveAgentIsLoading = _c.liveAgentIsLoading,
      messages = _c.messages;
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.chatContainer, chatContainer],
      testID: "chatWindow"
    }, header(this.toggleLivePerson, this.state, this.onSend), /*#__PURE__*/React.createElement(PnmacMacChat, __assign({
      ref: this.chatRef,
      scroller: function (func) {
        return _this.scroller = func;
      },
      isInitialized: chatIsInitialized,
      mobile: mobile,
      onLinkPress: onLinkPress,
      onKeyPress: function (e) {
        return _this.onKeyPress(e, _this.onSend);
      },
      isChatControl: true,
      messages: this.state.messages,
      onSend: this.onSend,
      loading: loading,
      loadEarlier: false,
      isLoadingEarlier: this.state.isLoadingEarlier,
      user: {
        _id: 1
      },
      renderBubble: this.renderBubble,
      isSpeakerOn: isSpeakerOn,
      isSpeaking: isSpeaking,
      isMicOn: isMicOn,
      isListening: isListening,
      isBlocked: isBlocked,
      liveAgentIsActive: liveAgentIsActive,
      liveAgentIsLoading: liveAgentIsLoading,
      onEndLiveAgentConClick: this.handleEndLiveAgentConClick
    }, this.props)), this.props.liveAgentEnabled && this.state.transferToLiveAgent ? (/*#__PURE__*/React.createElement(PnmacLiveChat, __assign({
      closeLiveChat: this.props.closeLiveChat,
      userDisplayName: this.props.userDisplayName || "Chat User",
      loanId: this.props.loanId || 0,
      borrowerId: this.props.borrowerId || 0,
      last4: this.props.sid || 0,
      idsUserId: this.props.idsUserId || null,
      MSRId: ((_a = this.props.layout) === null || _a === void 0 ? void 0 : _a.MSRId) || null,
      userSessionId: this.props.userChatSessionId,
      onLiveAgentBusy: this.handleLiveAgentBusyEvt,
      onConnectionCreated: this.handleLiveConnectedEvt,
      onConnectionFailed: this.handleLiveConnectFailedEvt,
      onMessageReceived: this.handleLiveMessageReceivedEvt,
      onConnectSessionCreated: this.handleConnectSessionCreated,
      onAgentTyping: this.handleAgentTypingEvt,
      onConnectionDropped: this.handleLiveConnectionDropEvt,
      agentApiUrl: this.props.agentApiUrl,
      agentContactFlowId: this.props.agentContactFlowId,
      agentInstanceId: this.agentInstanceId,
      initMessagesForAgentReview: messages,
      liveAgentTimerId: this.state.liveAgentTimerId
    }, this.props))) : null);
  };
  return PnmacChatWindow;
}(React.Component);
export default PnmacChatWindow;